import { render, staticRenderFns } from "./ColorChip.vue?vue&type=template&id=7f038af8"
import script from "./ColorChip.vue?vue&type=script&lang=js"
export * from "./ColorChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports